import { render, staticRenderFns } from "./ModalSearchPatients.vue?vue&type=template&id=52597840&scoped=true"
import script from "./ModalSearchPatients.vue?vue&type=script&lang=js"
export * from "./ModalSearchPatients.vue?vue&type=script&lang=js"
import style0 from "./ModalSearchPatients.vue?vue&type=style&index=0&id=52597840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52597840",
  null
  
)

export default component.exports